export const warehouse = [
    {
        dayNumber: 1,
        date: "1401/09/01",
        productCountInWarehouse: 1,
        productCountOutWarehouse: 4828,
    },
    {
        dayNumber: 2,
        date: "1401/09/02",
        productCountInWarehouse: 25,
        productCountOutWarehouse: 5529,
    },
    {
        dayNumber: 3,
        date: "1401/09/03",
        productCountInWarehouse: 35,
        productCountOutWarehouse: 8738,
    },
    {
        dayNumber: 4,
        date: "1401/09/04",
        productCountInWarehouse: 35,
        productCountOutWarehouse: 9387,
    },
    {
        dayNumber: 5,
        date: "1401/09/05",
        productCountInWarehouse: 0,
        productCountOutWarehouse: 7319,
    },
    {
        dayNumber: 6,
        date: "1401/09/06",
        productCountInWarehouse: 0,
        productCountOutWarehouse: 2830,
    },
    {
        dayNumber: 7,
        date: "1401/09/07",
        productCountInWarehouse: 7,
        productCountOutWarehouse: 3282,
    },
    {
        dayNumber: 8,
        date: "1401/09/08",
        productCountInWarehouse: 8,
        productCountOutWarehouse: 2144,
    },
    {
        dayNumber: 9,
        date: "1401/09/09",
        productCountInWarehouse: 0,
        productCountOutWarehouse: 1505,
    },
    {
        dayNumber: 10,
        date: "1401/09/10",
        productCountInWarehouse: 20,
        productCountOutWarehouse: 1246,
    },
    {
        dayNumber: 11,
        date: "1401/09/11",
        productCountInWarehouse: 678,
        productCountOutWarehouse: 2337,
    },
]
